import React from "react";
import size from "lodash/size";

import { Box, CircularProgress, Typography } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";

import EmptyTripsBlock from "components/contacts/EmptyTripsBlock";
import { useLoadTripsForCompany } from "../../hooks/useLoadTripsForCompany";
import { companyTripsGridColumns } from "./components";
import { useScreenSize } from "globals/hooks";

type CompanyTripsGridProps = {
  companyId: string;
};

function CompanyTripsGrid(props: CompanyTripsGridProps) {
  const { companyId } = props;

  // hooks
  const { isMobileView } = useScreenSize();
  const { trips, tripsLoading, fetchMoreTrips, hasNextPage, cursor } =
    useLoadTripsForCompany({ companyId });

  // handlers
  const handleRowScrollEnd = () => {
    if (hasNextPage) {
      fetchMoreTrips({
        variables: {
          cursor,
        },
      });
    }
  };

  const tripsGridStyle = isMobileView
    ? { mx: -2 }
    : {
        mx: -4,
        "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
          display: "none",
        },
      };

  return (
    <Box height="90%" sx={tripsGridStyle}>
      <Box my={3}>
        <Typography variant="h3" fontSize={"20px"} pl={2}>
          Trips
        </Typography>
      </Box>
      {tripsLoading ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          width="100%"
          height="100%"
        >
          <CircularProgress size={40} thickness={2} />
        </Box>
      ) : size(trips) ? (
        <DataGridPro
          disableColumnFilter
          disableColumnPinning
          disableSelectionOnClick
          disableChildrenSorting
          disableChildrenFiltering
          disableColumnMenu
          disableColumnReorder
          hideFooterRowCount
          disableMultipleColumnsSorting
          hideFooter
          aria-label="Company Trip Table"
          paginationMode="server"
          sortingMode="server"
          loading={tripsLoading}
          onRowsScrollEnd={handleRowScrollEnd}
          columns={companyTripsGridColumns}
          rows={trips}
        />
      ) : (
        <EmptyTripsBlock />
      )}
    </Box>
  );
}

export default CompanyTripsGrid;
